import { render, staticRenderFns } from "./bottom-nav.vue?vue&type=template&id=32f85785&"
import script from "./bottom-nav.vue?vue&type=script&lang=js&"
export * from "./bottom-nav.vue?vue&type=script&lang=js&"
import style0 from "./bottom-nav.vue?vue&type=style&index=0&id=32f85785&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports